module.exports = __webpack_public_path__ + "img/195.65e8f12b.jpg";